import { useMemo } from 'react';
import useSafeArray from './useSafeArray';
import { buildRowMoveTargets } from '../utils/lifecarePlanUtils';

// normalizes raw subsections + subtotals into a render-ready list so the
// future-care-needs component stays presentational
const useLifecareStudioFutureCareNeeds = ({ subsections, subsectionSubtotals }) => {
  const safeSubsections = useSafeArray(subsections);
  return useMemo(() => {
    const enrichedSubsections = safeSubsections.map((subsection, index) => ({
      subsection,
      index,
      subtotal: subsectionSubtotals?.[index] || 0,
      moveTargets: buildRowMoveTargets({ subsections: safeSubsections, currentIndex: index }),
    }));
    return {
      hasSubsections: enrichedSubsections.length > 0,
      enrichedSubsections,
    };
  }, [safeSubsections, subsectionSubtotals]);
};

export default useLifecareStudioFutureCareNeeds;
